import { useTranslation } from 'react-i18next';

import { DrawerActionButton, DrawerActions, DrawerTitle, StyledAssetDrawer } from './AssetPicker.styled';

interface AddFileDrawerProps {
  open: boolean;
  onClose: () => void;
  onChooseFromLibrary: () => void;
  onSelectFromAssets: () => void;
  title?: string;
}

export const AddFileDrawer = ({
  open,
  onClose,
  onChooseFromLibrary,
  onSelectFromAssets,
  title,
}: AddFileDrawerProps) => {
  const { t } = useTranslation();

  return (
    <StyledAssetDrawer
      open={open}
      onClose={onClose}
      title={<DrawerTitle>{title ?? t('assets.addFile')}</DrawerTitle>}
      data-testid="add-file-drawer"
    >
      <DrawerActions>
        <DrawerActionButton $withBorder onClick={onChooseFromLibrary} data-testid="add-file-choose-from-library">
          {t('general.chooseFromLibrary')}
        </DrawerActionButton>
        <DrawerActionButton $withBorder onClick={onSelectFromAssets} data-testid="add-file-select-from-assets">
          {t('assets.selectFromAssets')}
        </DrawerActionButton>
        <DrawerActionButton $bolder onClick={onClose} data-testid="add-file-cancel">
          {t('general.cancel')}
        </DrawerActionButton>
      </DrawerActions>
    </StyledAssetDrawer>
  );
};
